module.exports = __webpack_public_path__ + "static/media/hand.780cba74.PNG";